// src/utils/thaiDigits.js
// Helper สำหรับจัดการเลขไทย -> เลขอารบิก และแปลงค่าเป็นตัวเลข (ใช้ร่วมกับสรุปสถิติ)

const THAI_DIGITS = '๐๑๒๓๔๕๖๗๘๙';
const ARABIC_DIGITS = '0123456789';

// แปลงเลขไทยในข้อความเป็นเลขอารบิก (เก็บตัวอักษรอื่นไว้เหมือนเดิม)
export function thaiToArabicDigits(input) {
  const str = String(input ?? '');
  return str.replace(/[๐-๙]/g, (ch) => ARABIC_DIGITS[THAI_DIGITS.indexOf(ch)]);
}

// แปลงค่า (อาจเป็น string ที่มีเลขไทย/จุลภาค) เป็นตัวเลข สำหรับรวมสถิติ
export function parseThaiNumber(input) {
  if (input === null || input === undefined || input === '') return 0;
  const cleaned = thaiToArabicDigits(input).replace(/[,\s]/g, '');
  const n = parseFloat(cleaned);
  return Number.isFinite(n) ? n : 0;
}
